module.exports = __webpack_public_path__ + "media/images/covid/icons/sanitizer-7c62abd22a8350c202e6bf7f343c3ae3.svg";